import { render, staticRenderFns } from "./TablePeople.vue?vue&type=template&id=013ed12e"
import script from "./TablePeople.vue?vue&type=script&lang=js"
export * from "./TablePeople.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports